const authManager = {

  setVendorAccessToken: (accessToken) => {
    try {
      localStorage.setItem("accessVendorToken", accessToken);
    } catch (error) {
      console.error("Error setting access token:", error);
    }
  },

  getVendorAccessToken: () => {
    if (typeof window === "undefined") return null;
    return localStorage.getItem("accessVendorToken");
  },

  deleteVendorAccessToken: () => {
    if (typeof window !== "undefined") {
      localStorage.removeItem("accessVendorToken");
    }
  },

  hasVendorAccessToken: () => {
    if (typeof window === "undefined") return false;
    return !!localStorage.getItem("accessVendorToken");
  },
};

export default authManager;
